module.exports = __webpack_public_path__ + "img/健康_health-2.40073070.svg";